import React, { useEffect } from "react";
import { Loader } from "@egovernments/digit-ui-react-components";
import LTPSummary from "./LTPSummary";

function SearchSummary({ id, ref, isEmployee, setDeclarationChecked }) {
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const { isLoading, data: applicationDetails, refetch } = Digit.Hooks.obps.useLicenseDetails(
    tenantId,
    { applicationNumber: id },
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      // refetchOnWindowFocus: true,
      // refetchOnReconnect: true,
    }
  );
  const formData = applicationDetails?.applicationData;
  useEffect(() => {
    refetch();
  }, [refetch]);
  let consumerCode = id;
  const fetchBillParams = { consumerCode };
  const appType = formData?.applicationType;
  const BusinessService = formData?.businessService === `BPA_${appType?.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;

  const { applicationDetails: paymentDetails } = Digit.Hooks.useFetchBillsForBuissnessService(
    { businessService: BusinessService, ...fetchBillParams, tenantId: stateId },
    {
      enabled: consumerCode ? true : false,
      retry: false,
    }
  );
  const totalAmount = formData?.paymentDetails?.bill?.billDetails[0]?.amount || paymentDetails?.Bill?.[0]?.billDetails[0]?.amount;
  const docs = formData?.documents || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData?.PrevStateDocuments?.map((preDoc) => {
    improvedDoc.push({ ...preDoc, module: "OBPS" });
  });
  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });
  formData?.PrevStateNocDocuments?.map((preNocDoc) => {
    improvedDoc.push({ ...preNocDoc, module: "NOC" });
  });
  formData?.nocDocuments?.nocDocuments?.map((nocDoc) => {
    improvedDoc.push({ ...nocDoc, module: "NOC" });
  });

  const { data: pdfDetails, isLoading: pdfLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, { enabled: improvedDoc?.length > 0 ? true : false });

  let applicationDocs = formData?.tradeLicenseDetail?.applicationDocuments;

  if (pdfLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      {!isLoading && formData ? (
        <LTPSummary
          formData={formData}
          applicationDocs={applicationDocs}
          ref={ref}
          isEmployee={isEmployee}
          setDeclarationChecked={setDeclarationChecked}
        />
      ) : (
        <Loader />
      )}
    </React.Fragment>
  );
}

export default SearchSummary;
